import HeaderSteps from '../../ui/header-steps/header-steps'
import FundoRosaLogin from '../../../assets/fundo-rosa-cima.png'
import { Container } from './styles'
import { useCategoryFarm } from '../../../contexts/category-farm-context'
import React from 'react'

const StepsLayout = ({ children }) => {
  const { categoryFarm } = useCategoryFarm()
  return (
    <Container>
      <HeaderSteps/>
      <img src={FundoRosaLogin} className="wave" alt="Onda cor rosa" />
      <div className="welcome-text">
        <h4>{categoryFarm?.subTitle}</h4>
        <h1>{categoryFarm?.title}</h1>
      </div>
      {children}
    </Container>
  )
}

export default StepsLayout
